import Link from 'next/link';
import { Logo } from '../navbar/logo';
/**
 * Icons from https://simpleicons.org/
 */
var FacebookIcon = function (_a) {
    var className = _a.className;
    return (<svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>);
};
var LinkedinIcon = function (_a) {
    var className = _a.className;
    return (<svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>);
};
var XIcon = function (_a) {
    var className = _a.className;
    return (<svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>);
};
var YoutubeIcon = function (_a) {
    var className = _a.className;
    return (<svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>);
};
export var PublicPortalFooter = function (_a) {
    var _b, _c, _d, _e;
    var footerData = _a.footerData, governmentName = _a.governmentName, lightLogoUrl = _a.lightLogoUrl, darkLogoUrl = _a.darkLogoUrl, logoUrl = _a.logoUrl, logoClickUrl = _a.logoClickUrl;
    var currentYear = new Date().getFullYear();
    var socialLinks = [
        {
            name: 'Facebook',
            url: (_b = footerData === null || footerData === void 0 ? void 0 : footerData.facebookUrl) !== null && _b !== void 0 ? _b : null,
            icon: FacebookIcon,
        },
        {
            name: 'LinkedIn',
            url: (_c = footerData === null || footerData === void 0 ? void 0 : footerData.linkedinUrl) !== null && _c !== void 0 ? _c : null,
            icon: LinkedinIcon,
        },
        {
            name: 'X',
            url: (_d = footerData === null || footerData === void 0 ? void 0 : footerData.twitterUrl) !== null && _d !== void 0 ? _d : null,
            icon: XIcon,
        },
        {
            name: 'YouTube',
            url: (_e = footerData === null || footerData === void 0 ? void 0 : footerData.youtubeUrl) !== null && _e !== void 0 ? _e : null,
            icon: YoutubeIcon,
        },
    ].filter(function (link) { return link.url; });
    return (<footer className="border-t border-slate-300 bg-slate-100 py-8 dark:border-slate-600 dark:bg-slate-800">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center gap-4 text-center">
          {/* Copyright */}
          <div className="text-sm text-gray-600 dark:text-gray-400">
            © {currentYear}{' '}
            {logoClickUrl ? (<Link href={logoClickUrl} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                {governmentName}
                <span className="sr-only"> (opens in a new tab)</span>
              </Link>) : (governmentName)}
          </div>

          {/* Social Media Icons */}
          {socialLinks.length > 0 && (<div className="flex items-center gap-4">
              {socialLinks.map(function (link) {
                var Icon = link.icon;
                return (<Link key={link.name} href={link.url} target="_blank" rel="noopener noreferrer" aria-label={"Visit our ".concat(link.name, " page (opens in a new tab)")} className="text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100">
                    <Icon className="h-5 w-5"/>
                  </Link>);
            })}
            </div>)}

          {/* Bottom Row */}
          <div className="flex flex-wrap items-center justify-center gap-2 text-sm text-gray-600 dark:text-gray-400">
            <span>Powered by</span>
            <span className="font-semibold">
              <Logo url="https://govinity.com" alt={'govinity logo'} variant={'full'} icon={logoUrl} title={'Govinity'} lightLogo={lightLogoUrl} darkLogo={darkLogoUrl} openInNewTab={true} fullLogoWidth={96}/>
            </span>
            <span className="mx-1">|</span>
            <span>All rights reserved</span>
            <span className="mx-1">|</span>
            <Link href={'https://govinity.com/privacy-policy'} target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 dark:hover:text-gray-100">
              Privacy Policy
              <span className="sr-only"> (opens in a new tab)</span>
            </Link>
            <span className="mx-1">|</span>
            <Link href={'https://govinity.com/accessibility-statement'} target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 dark:hover:text-gray-100">
              Accessibility Statement
              <span className="sr-only"> (opens in a new tab)</span>
            </Link>
          </div>
        </div>
      </div>
    </footer>);
};
